import { typography } from '@shared/tokens/typography.stylex';
import { palette } from '@shared/tokens/palette.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  text: {
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    color: palette['grey-500'],
    ':not(#__unused__) > div': {
      outline: 'none !important',
    },
    ':not(#__unused__) a': {
      color: colors.accentText,
    },
  },
});
